import React from 'react';
import { TreeSelect } from 'antd';
const { SHOW_PARENT, TreeNode } = TreeSelect;

const ProjectTree = (props) => {
	const { projectTree = [], allProjectList = [], onChange, value = [] } = props;
	console.log(value, 'value');

	// const onProjectChange = (value) => {
	// 	this.setState({ communityScope: value });
	// };

	// 树节点过滤
	const filterTreeNode = (inputValue, treeNode) => {
		return treeNode.title.indexOf(inputValue) > -1;
	};

	// 渲染项目树结构
	const renderProjectTree = (data) => {
		// const {}
		return data.map(node => {
			const { projects = [], projectId, projectName } = node;
			const disabled = projectTree.every(p => p.projectId !== projectId);
			if (projects && projects.length > 0) {
				return (
					<TreeNode
						key={projectId.toString()}
						value={projectId.toString()}
						title={projectName}
						data-item={node}
						disabled={disabled}
					>
						{this.renderProjectTree(projects)}
					</TreeNode>
				);
			}
			return <TreeNode
				key={projectId.toString()}
				value={projectId.toString()}
				title={projectName}
				data-item={node}
				disabled={disabled}
			/>;
		});
	};

	const treeCommonProps = {
		treeCheckable: true,
		searchPlaceholder: '请选择',
		showSearch: true,
		multiple: true,
		allowClear: true,
		dropdownStyle: { maxHeight: 400, overflow: 'auto' },
		dropdownMatchSelectWidth: true,
		disabled: false,
		filterTreeNode: filterTreeNode
	};

	const projectTreeProps = {
		value: value.map(pid => pid.toString()),
		onChange: onChange,
		showCheckedStrategy: SHOW_PARENT,
	};
	// 渲染项目树结构
	return <TreeSelect
		{...treeCommonProps}
		{...projectTreeProps}
	>
		{renderProjectTree(allProjectList)}
	</TreeSelect>;
};

export default ProjectTree;
